// src/components/ProtectedRoute.jsx
// ─────────────────────────────────────────────────────────────────────────────
//  Wraps any route that requires authentication.
//  Shows a full-screen spinner while the bootstrap check is running.
//  Redirects to /login if not authenticated.
//  Redirects to /dashboard if authenticated but role not allowed.
// ─────────────────────────────────────────────────────────────────────────────

import React from 'react';
import { Navigate } from 'react-router-dom';
import { Spin } from 'antd';
import { useAuth } from '../context/AuthContext';

const ProtectedRoute = ({ children, allowedRoles, allowedPermissions }) => {
  const { isAuthenticated, user, loading } = useAuth();

  // Still checking the existing session — don't flash the login page
  if (loading) {
    return (
      <div style={{
        display:        'flex',
        justifyContent: 'center',
        alignItems:     'center',
        height:         '100vh',
        background:     '#0f172a',
      }}>
        <Spin size="large" />
      </div>
    );
  }

  // Not logged in
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (allowedRoles && !allowedRoles.includes(user.role)) {
    return <Navigate to="/dashboard" replace />;
  }

  if (allowedPermissions?.length) {
    const allowed =
      user.role === "admin" ||user.role === "user" ||
      allowedPermissions.some((code) =>
        Array.isArray(user.permissions) ? user.permissions.includes(code) : false,
      );
    if (!allowed) {
      return <Navigate to="/dashboard" replace />;
    }
  }

  return children;
};

export default ProtectedRoute;
